var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Up = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 8 8", a11yTitle: "Up" }, props, { children: _jsx("path", { d: "M0.44309 5.62281C0.548956 5.79267 0.753836 5.89725 0.978224 5.89549L6.65771 5.85092C6.8821 5.84916 7.08531 5.74138 7.1885 5.56987C7.28674 5.40629 7.27836 5.2151 7.16634 5.0588L4.29495 1.04914C4.18388 0.893403 3.99068 0.801685 3.77818 0.803353C3.56569 0.80502 3.37395 0.899759 3.26502 1.05694L0.456915 5.11117C0.347678 5.26949 0.342293 5.46079 0.44309 5.62281Z", fill: "#000" }) }))); });
//# sourceMappingURL=Up.js.map